var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newsPresent)?_c('div',{staticClass:"col data-block news-block rich-text"},[_c('div',{staticClass:"wrapper",class:_vm.newsBarClasses},[_c('div',{attrs:{"title":"View News"}},[_vm._v("\n        "+_vm._s(this.news)+"\n")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }